import { openDoNotSell, openPrivacyChoices, useConsentControls } from "./provider";
export function PrivacyLinks() {
  const controls = useConsentControls();
  return <div className="privacy-links"><a href="/privacy" target="_blank" rel="noopener">Privacy</a>{controls.europe ? <button type="button" onClick={openPrivacyChoices}>Privacy and cookie settings</button> : null}{controls.us ? <button type="button" onClick={openDoNotSell}>Do not sell or share</button> : null}</div>;
}
